import { render, staticRenderFns } from "./dispatcherInfo.vue?vue&type=template&id=39406d58&scoped=true&"
import script from "./dispatcherInfo.vue?vue&type=script&lang=js&"
export * from "./dispatcherInfo.vue?vue&type=script&lang=js&"
import style0 from "./dispatcherInfo.vue?vue&type=style&index=0&id=39406d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39406d58",
  null
  
)

export default component.exports